
import {mergeMap, map, filter, pairwise, first} from 'rxjs/operators';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute, NavigationStart} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TitleService} from './services/local/title/title.service';
import { PrimeNGConfig } from 'primeng/api';

import {LocalStorageService} from 'ngx-webstorage';
import {takeUntil} from 'rxjs/operators';
import {Angulartics2GoogleAnalytics} from 'angulartics2/ga';
import {environment} from '../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {SessionService} from './services/local/session/session.service';
import {BroadcasterService} from './services/local/broadcaster/broadcaster.service';
import {WebsocketNotifications} from './shared/constants/websocketNotifications';
import {Subject} from 'rxjs';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'lina-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  disableFormControls = false;
  notificationEvents = WebsocketNotifications;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
    private translate: TranslateService,
    private storage: LocalStorageService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private iconReg: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private sessionService: SessionService,
    private broadCaster: BroadcasterService,
    private snackBar: MatSnackBar,
    private config: PrimeNGConfig
  ) {
    if (environment.production) {
      angulartics2GoogleAnalytics.startTracking();
    }

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
         if (event.url.indexOf('auth') === -1 || event.url.indexOf('auth/changeusername') > -1) {
          this.sessionService.targetState = event.url;
         }
        }
      });

    translate.setDefaultLang('sv');

    if (this.sessionService.appSettings.lang) {
      translate.use(this.sessionService.appSettings.lang);
    } else {
      translate.use('sv');
    }
    translate.get('primeng').subscribe(res => this.config.setTranslation(res));

    this.iconReg.addSvgIcon('recycle', this.sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/recycle.svg'))
      .addSvgIcon('apple', this.sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/apple.svg'))
      .addSvgIcon('qrcode', this.sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/qrcode.svg'));
  }

  ngOnInit() {
    // Navigation log
    /*this.router.events.pipe(filter(event => event instanceof NavigationEnd), pairwise()).subscribe((e) => {
      e.forEach(ev => {
        console.log('NAVIGATION PREVIOUS => ', ev);
      });
    });*/

    this.broadCaster.on('disableFormControls').pipe(
      takeUntil(this.unsubscribe)).subscribe(event => {
      this.disableFormControls = event;
    });

    this.broadCaster.on(this.notificationEvents.appUpdated).pipe(
      takeUntil(this.unsubscribe)).subscribe(event => {
      const failedSnackBar = this.snackBar.open(this.translate.instant('LINA_CLIENT_UPDATED'), this.translate.instant('RELOAD'), {
        duration: 0
      });

      failedSnackBar.onAction().subscribe(() => {
        window.location.reload();
      });
    });

    this.router.events.pipe(
      takeUntil(this.unsubscribe),
      filter((event) => event instanceof NavigationEnd),
      map((event) => {
        return {event: event as NavigationEnd, route: this.activatedRoute};
      }),
      map((eventObject) => {
        while (eventObject.route.firstChild) { eventObject.route = eventObject.route.firstChild; }
        return eventObject;
      }),
      filter((eventObject) => eventObject.route.outlet === 'primary'),
      mergeMap((eventObject) => {
        if (eventObject.event.url.indexOf('/app/') > -1 && eventObject.event.url.indexOf('startpage') === -1) {
          this.sessionService.setPageHistory({
            url: eventObject.event.url.split('?')[0],
            data: {section: eventObject.route.snapshot.data.section, page: eventObject.route.snapshot.data.page, caseNumber: eventObject.route.snapshot.data.theCase ? eventObject.route.snapshot.data.theCase.CaseNumber : null},
            created: new Date()
          });
        }
        return eventObject.route.data;
      }))
      .subscribe((event) => {
        this.titleService.setTitle({section: event['section'], page: event['page']});
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
